import * as H from "history";
import * as React from "react";
import { match as Match } from "react-router";

import { Client } from "../../../../domain/model/client";
import { Company } from "../../../../domain/model/company";

import ClientMyPageClientEditComponent from "./client_mypage_edit_client";
import ClientMyPageCompanyEditComponent from "./client_mypage_edit_company";
import ClientMyPageEmailUpdateComponent from "./client_mypage_email_update";
import ClientMyPageClientInfoComponent from "./client_mypage_info_client";
import ClientMyPageCompanyInfoComponent from "./client_mypage_info_company";
import ClientMyPagePasswordUpdateComponent from "./client_mypage_password_update";

import Progress from "../../../common/organism/progress";

interface IProps {
  isInit: boolean;
  isLoading: boolean;
  location: H.Location;
  match: Match<{ action: string }>;
  client: Client | null;
  company: Company | null;
  handleUpdateCompanySubmit: (values: any) => void;
  handleUpdateClientSubmit: (values: any) => void;
  handleUpdatePasswordSubmit: (values: any) => void;
  handleUpdateEmailSubmit: (values: any) => void;
}

const ClientMypageComponent: React.FC<IProps> = (props) => {
  const {
    isInit,
    isLoading,
    location,
    match,
    client,
    company,
    handleUpdateCompanySubmit,
    handleUpdateClientSubmit,
    handleUpdatePasswordSubmit,
    handleUpdateEmailSubmit,
  } = props;

  const pathName: string = location.pathname;
  const action: string | null = match.params ? match.params.action : null;

  // 初期化
  if (isInit) {
    return <Progress canAnimation={false} />;
  }

  let res: JSX.Element;

  switch (true) {
    case /^\/client\/mypage\/client/.test(pathName): {
      if (action !== "_edit") {
        // 通常画面
        res = (
          <ClientMyPageClientInfoComponent
            isLoading={isLoading}
            client={client}
            company={company}
          />
        );
      } else {
        // 編集画面
        res = (
          <ClientMyPageClientEditComponent
            isLoading={isLoading}
            client={client}
            handleUpdateClientSubmit={handleUpdateClientSubmit}
          />
        );
      }

      break;
    }

    case /^\/client\/mypage\/company/.test(pathName): {
      if (action !== "_edit") {
        // 通常画面
        res = (
          <ClientMyPageCompanyInfoComponent
            isLoading={isLoading}
            company={company}
          />
        );
      } else {
        // 編集画面
        res = (
          <ClientMyPageCompanyEditComponent
            isLoading={isLoading}
            company={company}
            handleUpdateCompanySubmit={handleUpdateCompanySubmit}
          />
        );
      }

      break;
    }

    case /^\/client\/mypage\/password/.test(pathName): {
      res = (
        <ClientMyPagePasswordUpdateComponent
          isLoading={isLoading}
          handleUpdatePasswordSubmit={handleUpdatePasswordSubmit}
        />
      );

      break;
    }

    case /^\/client\/mypage\/email/.test(pathName): {
      res = (
        <ClientMyPageEmailUpdateComponent
          isLoading={isLoading}
          handleUpdateEmailSubmit={handleUpdateEmailSubmit}
        />
      );

      break;
    }

    default: {
      res = <div />;
    }
  }

  return res;
};

export default ClientMypageComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/client_mypage.tsx